import _ from 'lodash';
import moment from 'moment';
import pluralize from 'pluralize';

import { DAYSOFWEEK, MONTHS } from 'constants';
import { alerts } from 'modules/alerts/actions';

export function handleServerError(errors, dispatch, submitError) {
  if (submitError) console.error(submitError);
  if (submitError) alerts.error({ subtitle: 'Server error, please let the system administrator know right away!' });
}

export function formatFileUploadFormData(data, filenames) {
  const files = _.pick(data, filenames);
  const fields = _.omit(data, filenames);
  const hasFiles = _.some(files, file => file instanceof FileList || (_.isArray(file) && _.some(file, subfile => subfile instanceof FileList)));

  _.forEach(files, (file, key) => {
    if (_.isArray(file)) {
      fields[key] = _.flatten(_.filter(file, subfile => !(subfile instanceof FileList)));
    }
  });

  // If there are no new files bail out
  if (!hasFiles) return fields;

  const formData = new FormData();

  formData.append('body', JSON.stringify(fields));

  _.forEach(files, (file, key) => {
    appendFile(formData, file, key);
  });

  return formData;
}

function appendFile(formData, file, key) {
  if (_.isArray(file)) {
    _.forEach(file, subfile => appendFile(formData, subfile, key));
    return;
  }

  if (!(file instanceof FileList)) return;

  formData.append(key, file[0]);
}

export function getRecurrenceDescription(rules) {
  if (!rules || !rules.enabled) return '';

  const { interval, frequency, day, monthType, dayOffset, date, month, skipWeekends } = rules;
  const allowSkipWeekends = interval === 'day' || (_.includes(['month', 'year'], interval) && monthType === 'byDate');

  let description = `Recurs every ${frequency} ${pluralize(interval, Number(frequency))}`;

  if (interval === 'week') description += ` on ${DAYSOFWEEK[day].label}`;
  if (interval === 'month' && monthType === 'byDay') description += ` on the ${getOrdinal(Number(dayOffset) + 1)} ${DAYSOFWEEK[day].label}`;
  if (interval === 'month' && monthType === 'byDate') description += ` on the ${getOrdinal(date)}`;
  if (interval === 'year' && monthType === 'byDay') description += ` on the ${getOrdinal(Number(dayOffset) + 1)} ${DAYSOFWEEK[day].label} of ${MONTHS[month].label} `;
  if (interval === 'year' && monthType === 'byDate') description += ` on ${MONTHS[month].label} ${getOrdinal(date)}`;

  if (skipWeekends && allowSkipWeekends) description += ' (skipping weekends)';

  return description;
}

export function getOrdinal(n) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function getNextRecurrenceDate(rules, task) {
  if (!rules || !rules.enabled) return '';

  const { interval, frequency, month, monthType, day, skipWeekends } = rules;
  const { dueDate } = task;
  const currentDate = moment(dueDate);
  const allowSkipWeekends = interval === 'day' || (_.includes(['month', 'year'], interval) && monthType === 'byDate');
  let newDate = currentDate.clone();

  if (interval === 'day') newDate.add(frequency, interval);

  if (interval === 'week') {
    newDate.day(day);

    newDate.add(newDate.isAfter(currentDate, 'day') ? frequency - 1 : frequency, interval);
  }

  if (interval === 'month') {
    const newMonth = adjustDate(newDate, rules);

    newDate.add(newMonth.isAfter(currentDate, 'day') ? frequency - 1 : frequency, interval);

    newDate = adjustDate(newDate, rules);
  }

  if (interval === 'year') {
    const newYear = adjustDate(newDate.month(month), rules);

    newDate.add(newYear.isAfter(currentDate, 'day') ? frequency - 1 : frequency, interval);

    newDate = adjustDate(newDate.month(month), rules);
  }

  if (skipWeekends && allowSkipWeekends) {
    if (newDate.day() === 0) newDate.add(1, 'day');
    if (newDate.day() === 6) newDate.add(2, 'days');
  }

  return newDate;
}

export function adjustDate(current, rules) {
  const { monthType, day, dayOffset, date } = rules;

  if (monthType === 'byDate') {
    return current.date(current.daysInMonth() < date ? current.daysInMonth() : date);
  }

  if (monthType === 'byDay') {
    const currentDate = moment(current).startOf('month');
    const newDate = currentDate.clone().day(day);

    if (newDate.month() !== currentDate.month()) newDate.add(1, 'week');

    return newDate.add(dayOffset, 'weeks');
  }
}



// WEBPACK FOOTER //
// ./app/utils/form-utils.js